import growthbook from '@/utils/growthbook';

export default {
  methods: {
    featureAvailable(feature) {
      return growthbook.isOn(feature);
    },
  },
};
